import { render, staticRenderFns } from "./RentalCarPricingRepairShop.vue?vue&type=template&id=304fe0b0&scoped=true"
import script from "./RentalCarPricingRepairShop.vue?vue&type=script&lang=js"
export * from "./RentalCarPricingRepairShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304fe0b0",
  null
  
)

export default component.exports